<div class="card shadow mb-4 bloque-6">
  <!-- Card Header - Dropdown -->
  <div
    class="card-header py-3 d-flex flex-row align-items-center justify-content-between"
  >
    <h6 class="m-0 font-weight-bold text-secondary">Detalle OC</h6>
    <div>
      <!-- <button class="action border rounded-circle btn-light">
        <i class="bi bi-chevron-left"></i>
      </button>
      <button class="action border rounded-circle btn-light">
        <i class="bi bi-chevron-right"></i>
      </button> -->
    </div>
  </div>
  <!-- Card Body -->
  <div class="card-body">
    <div class="p-2" *ngIf="isLoading">
      <p-skeleton height="455px" />
    </div>
    <div *ngIf="!isLoading">
    <div class="chart-pie">
      <p-chart type="doughnut" [data]="data" [options]="options" height="280" />
    </div>
    </div>
    <div class="mt-3">
      <div class="row text-center">
        <div class="col-6">
          <span>{{ value1 }}</span>
        </div>
        <div class="col-6">
          <span>{{ label1 }}</span>
        </div>
      </div>

      <div class="row text-center mt-3">
        <div class="col-12">
          <h3>
            <b
              ><span>{{ value2 }}</span></b
            >
          </h3>
        </div>
      </div>

      <div class="row text-center mt-3">
        <div class="col-5">
          <span>{{ value3 }}</span>
        </div>
        <div class="col-7">
          <span>{{ label3 }}</span>
        </div>
      </div>
    </div>

    <!-- <div class="mt-3 text-center small">
      <span class="mr-2">
        <i class="bi bi-circle-fill text-primary"></i> Cotizacion
      </span>
      <span class="mr-2">
        <i class="bi bi-circle-fill text-success"></i> Convenio
      </span>
      <span class="mr-2">
        <i class="bi bi-circle-fill text-info"></i> Directa
      </span>
    </div> -->
  </div>
</div>
